import { render, staticRenderFns } from "./servicosEditar.vue?vue&type=template&id=325f5242&scoped=true&"
import script from "./servicosEditar.vue?vue&type=script&lang=js&"
export * from "./servicosEditar.vue?vue&type=script&lang=js&"
import style0 from "./servicosEditar.vue?vue&type=style&index=0&id=325f5242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f5242",
  null
  
)

export default component.exports